<template>
    <div class="flex flex-col min-h-screen max-h-screen w-full fixed" style="background: transparent;">
    <div class="flex flex-1" style="gap: 18px; padding: 18px;">
      <component
        :is="currentSidebarComponent"
        :class="[
          'sidebar-shell',
          currentSidebarComponent === 'ClientSideBar' ? 'hidden md:inline-flex' : ''
        ]"
      />
      <div class="flex-grow w-full max-w-full overflow-hidden" style="height: calc(100vh - 36px);">
        <router-view v-slot="{ Component }">
          <div class="w-full h-full overflow-hidden rounded-lg">
            <component :is="Component" />
          </div>
        </router-view>
      </div>
    </div>
  </div>
</template>

<script>
  import AppSideBar from '@/components/sidebar/sideBar.vue';
  import ClientSideBar from '@/components/sidebar/sidebarCliente.vue';

export default {
    name: 'HomeView',
    components: {
        ClientSideBar,
        AppSideBar,
    },
    data() {
        return {
            baseURL: process.env.VUE_APP_URL_BASE,
            currentSidebarComponent: null,
        };
    },
    methods: {
        checkUserTypeFromLocalStorage() {
            try {
                const userType = JSON.parse(localStorage.getItem('tipo'));
                if (userType.nome === 'cliente') {
                    
                    this.currentSidebarComponent = 'ClientSideBar'; 
                    // window.location.reload();
                } else {
                    this.currentSidebarComponent = 'AppSideBar'; 
                }
            } catch (error) {
                console.log('Erro ao verificar o tipo de utilizador no local storage:', error);
            }
        },
    },
    created() {
        this.checkUserTypeFromLocalStorage();
    },
//     mounted() {
//   document.documentElement.style.setProperty('--fundoApp', '#2e2e48')
// }
};
</script>

<style scoped>
.sidebar-shell {
  flex: 0 0 auto;
}

.glass-scrollbar {
  scrollbar-width: thin;
  scrollbar-color: rgba(138,160,255,.25) transparent;
}

.glass-scrollbar::-webkit-scrollbar {
  width: 6px;
}
.glass-scrollbar::-webkit-scrollbar-track {
  background: transparent;
}
.glass-scrollbar::-webkit-scrollbar-thumb {
  background: rgba(138,160,255,.25);
  border-radius: 999px;
}
</style>
